export const meterClassController = (res) => {
  if (res.data.response == "invalid session") {
    return {
      message: "Invalid sessionid",
      type: "error",
    };
  } else if (res.data.response == "failure") {
    return {
      message: "Operation failed. Please try again",
      type: "error",
    };
  } else if (res.data.response == "true") {
    return {
      message: res.data,
      type: "success",
    };
  } else if (res.data.response == "false") {
    return {
      message: res.data,
      type: "error",
    };
  } else if (res.data) {
    return {
      message: res.data,
      type: "success",
    };
  }
};
